module.exports = __webpack_public_path__ + "static/media/Hoo.Be.e130406c.png";